export const createAuthApi = (customFetch) => ({
    postSubmitApplication: async (event_id, userAnswers) => {
        const date = { 
            nextEventId: event_id, 
            userAnswers: userAnswers 
        }
        try {
            const response = await customFetch('submitApplication', {
                method: "POST",
                body: JSON.stringify(date)
            });

            if (response) {
                return response;
            }
            return null;
        } catch (error) {
            console.error("Error logging out:", error);
            return null;
        }
    },
    getApplicationsQuestions: async (event_id) => {
        const date = { 
            nextEventId: event_id, 
        }
        try {
            const response = await customFetch('applicationsQuestions', {
                method: "POST",
                body: JSON.stringify(date)
            });

            if (response) {
                return response;
            }
            return null;
        } catch (error) {
            console.error("Error logging out:", error);
            return null;
        }
    },

})